import React, { useState } from "react";
import { useAppDispatch } from "../../../../../src/app/hooks";
import StageWorkflowDecisionModal from "../../../../../src/features/stageWorkflow/components/StageWorkflowDecisionModal";
import {AddStageRequest,CaseStageAction,CaseStageEnum,} from "../../../../../src/api/caseStages";
import { AcceptButton } from "../../../../../src/components/ui/button/v2/AcceptButton";
import { useParams } from "react-router-dom";
import { updateCaseStage } from "../../logic/thunks";
import { showErrorToast, showSuccessToast } from "../../../../../src/lib/toast";

export const ApproveIOAppAuth: React.FC<{
  next_stage: CaseStageEnum;
}> = ({ next_stage }) => {
  const dispatch = useAppDispatch();
  const { id: caseId } = useParams<{ id: string }>();

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleOpen = (): void => {
    setIsModalOpen(true);
  };

  const handleClose = (): void => {
    if (isLoading) return;
    setIsModalOpen(false);
  };

  const handleApprove = async (): Promise<void> => {
    if (!caseId) return;

    try {
      setIsLoading(true);

      const request: AddStageRequest = {
        stage: next_stage,
        source_action: CaseStageAction.APPROVE_IO_APP_AUTH,
      };

      await dispatch(
        updateCaseStage({
          caseId,
          request,
        })
      ).unwrap();

      showSuccessToast("IO Appointing Authority approved successfully");
      setIsModalOpen(false);
    } catch (error) {
      showErrorToast("Failed to approve IO Appointing Authority");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <AcceptButton label="Approve" onClick={handleOpen}/>

      <StageWorkflowDecisionModal
        isOpen={isModalOpen}
        variant="accept"
        title="Approve IO App Authority"
        subtitle="Are you sure you want to approve this?"
        primaryButtonLabel="Approve"
        onPrimaryAction={handleApprove}
        onClose={handleClose}
        primaryDisabled={isLoading}
        primaryLoading={isLoading}
      />
    </>
  );
};
